<div class="document-viewer">
  <ng-container *ngIf="isPdf && pdfSrc">
    <base-pdf-viewer
      [src]="pdfSrc"
      [fileName]="fileName"
      [customToolbar]="pdfViewerToolbar"
      [height]="height"
      [hideBorder]="hideBorder"
    ></base-pdf-viewer>
  </ng-container>

  <ng-container *ngIf="!isPdf && imageSrc">
    <ng-container *ngTemplateOutlet="pdfViewerToolbar"></ng-container>
    <base-image-viewer [src]="imageSrc"></base-image-viewer>
  </ng-container>
</div>

<ng-template #pdfViewerToolbar>
  <base-document-viewer-toolbar
    [title]="fileName"
    [modalRef]="modalRef"
    [isImageViewer]="!isPdf"
    (downloadImage)="downloadImage.emit()"
  ></base-document-viewer-toolbar>
  <div
    *ngIf="isCustomBodyText"
    class="pb-5"
  >
    <p>{{ customBodyText }}</p>
  </div>
</ng-template>
